import { render, staticRenderFns } from "./nuevaResolucion.vue?vue&type=template&id=6b3aac69&scoped=true"
import script from "./nuevaResolucion.vue?vue&type=script&lang=js"
export * from "./nuevaResolucion.vue?vue&type=script&lang=js"
import style0 from "./nuevaResolucion.vue?vue&type=style&index=0&id=6b3aac69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3aac69",
  null
  
)

export default component.exports